import React, { useEffect, useState, useRef } from 'react';
import Heading from '../../../../../common/element/Heading';
import { setBreadcrumbs } from '../../../../../redux/Admin/breadcrumbsSlice';
import { setCompanyName, resetCompanyName } from '../../../../../redux/Admin/companyViewSlice';
import { useDispatch, useSelector } from 'react-redux';

import EmployeesTab from './Tabs/Employee/EmployeesTab';
import CompanyInfoCard from './Tabs/OverView/OverView';
import Batches from '../../../Batches';
import CompanyCoaches from './Tabs/CompanyCoaches/CompanyCoaches';
import InterViewCandidate from './Tabs/Interview Candidate/InterView';
import EmployeeView from './Tabs/Employee/EmployeeView';
import { useLocation, useNavigate } from 'react-router-dom';
import BatchesSessions from './Tabs/Sessions/Session';
import Button from '../../../../../common/element/Buttons';
import { getCompanyById } from '../../../../../redux/Companies/companiesSlice';
import { selectCompanyDetail } from '../../../../../redux/Companies/companiesSelector';
import SessionView from './Tabs/Sessions/View';
import { selectUserData } from '../../../../../redux/auth/authSelector';
import { ROLES } from '../../../../../config/rolePermissions';
import Management from '../../../Hr/Management';
import ToolManagmentCard from '../../../../../common/element/Card/ToolManagmnetCard';
import ViewManagement from '../../../Hr/Management/View';
import BatchView from '../../../Batches/View/View';
import ManagementEmployeeView from "../../../Hr/Management/View/Tabs/Employee/EmployeeView";
import { CompanyAvatar } from '../../../../../common/element/CompanyAvatar/CompanyAvatar';

// ✅ 1. Import the ImagePreviewModal
import ImagePreviewModal from '../../../../../common/ImagePreviewModal/ImagePreviewModal';

const ViewCompany = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const employeeId = searchParams.get('employeeId');
  const empId = searchParams.get('empId');
  const batchId = searchParams.get("batchId");
  const managementId = searchParams.get('managementId');
  const coachId = searchParams.get("coachId");
  const sessionView = searchParams.get('companySessionView');
  const sessionName = searchParams.get('sessionName');
  const tabFromUrl = searchParams.get('tab') || 'overview';
  const companyId = searchParams.get('companyId');
  const sessionTab = searchParams.get('sessionTab');
  const mangmentView = searchParams.get('view');
  const sessionId = searchParams.get('sessionId');
  const SessionId = searchParams.get('SessionId');
  const sessionIdAny = sessionId || SessionId;
  const companyDetail = useSelector(selectCompanyDetail);
  const storedCompanyName = useSelector((state) => state.companyView?.companyName);
  const storedManagementName = useSelector((state) => state.managementView?.managementName);
  const companyData = companyDetail || {};
  const storedSessionName = useSelector((state) => state.sessionView?.sessionName);
  const userData = useSelector(selectUserData);
  const isAdmin = userData?.role_name === ROLES.ADMIN;
  
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  // ✅ 2. State for the Image Preview Modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: "",
    alt: "",
  });

  console.log(companyData, "companyDatacompanyDatacompanyData")
  useEffect(() => {
    // If user is not admin and tries to access admin-only tabs, redirect to overview
    if (!isAdmin && (tabFromUrl === 'interviewCandidates' || tabFromUrl === 'coaches' || tabFromUrl === 'batch')) {
      const params = new URLSearchParams(location.search);
      params.set('tab', 'overview');
      navigate(`?${params.toString()}`, { replace: true });
      setActiveTab('overview');
    } else {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl, isAdmin, location.search, navigate]);

  const refresh = () => {
    dispatch(getCompanyById(companyId));
  };

  useEffect(() => {
    refresh()
  }, [dispatch, companyId]);

  // Keep company name in redux so it can be used in breadcrumbs and survive refresh
  useEffect(() => {
    if (companyDetail && companyDetail.company_name) {
      dispatch(setCompanyName(companyDetail.company_name));
      if (!employeeId && !sessionView && !batchId && !coachId && !sessionIdAny && sessionTab !== 'view') {
        dispatch(
          setBreadcrumbs([
            { label: "Companies", url: "/companies", home: "/companies" },
            { label: companyDetail.company_name, url: `/companies/companyview?companyId=${companyId}&tab=${tabFromUrl}` },
          ])
        );
      }
    }
  }, [companyDetail, dispatch]);

  useEffect(() => {
    const isReload = { current: false };
    const onBeforeUnload = () => {
      isReload.current = true;
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      if (!isReload.current) {
        dispatch(resetCompanyName());
      }
    };
  }, [dispatch]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    const params = new URLSearchParams(location.search);
    params.set('tab', tabId);
    params.delete('employeeId');
    params.delete('sessionView');

    navigate(`?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    const storedName = storedCompanyName || companyData?.company_name || '';
    const companyLabel = storedName || 'View Company';
    const sessionLabel = storedSessionName || sessionName || 'Session View';

    if (activeTab === 'sessions' && (sessionTab === 'view' || sessionIdAny)) {
      dispatch(
        setBreadcrumbs([
          { label: 'Companies', url: '/companies', home: '/companies' },
          { label: companyLabel, url: `/companies/companyview?companyId=${companyId}&tab=${tabFromUrl}` },
          { label: sessionLabel, url: `/companies/companyview?companyId=${companyId}&tab=${tabFromUrl}&SessionId=${sessionIdAny}&sessionTab=view` },
        ])
      );
      return;
    }
    if (activeTab === 'managementSessions' && sessionView === 'view') {
      const managementLabel = storedManagementName || 'View Management';
      dispatch(
        setBreadcrumbs([
          { label: "Companies", url: "/companies", home: "/companies" },
          { label: companyLabel, url: `/companies/companyview?companyId=${companyId}&tab=management` },
          { label: managementLabel, url: `/companies/companyview?companyId=${companyId}&tab=managementSessions&empId=${empId}&view=true` },
          { label: sessionLabel, url: `/companies/companyview?companyId=${companyId}&view=true&tab=managementSessions&empId=${empId}&sessionId=${sessionId}&companySessionView=view` },
        ])
      );
      return;
    }

    if (mangmentView || empId) {
      const managementLabel = storedManagementName || 'View Management';
      dispatch(
        setBreadcrumbs([
          { label: "Companies", url: "/companies", home: "/companies" },
          { label: companyLabel, url: `/companies/companyview?companyId=${companyId}&tab=management` },
          { label: managementLabel, url: `/companies/companyview?companyId=${companyId}&tab=managementSessions&empId=${empId}&view=true` },
        ])
      );
      return;
    }

    if (activeTab === 'batch' && batchId) {
      const batchLabel = searchParams.get('batchName') || 'Batch View';
      dispatch(
        setBreadcrumbs([
          { label: 'Companies', url: '/companies', home: '/companies' },
          { label: companyLabel, url: `/companies/companyview?companyId=${companyId}&tab=batch` },
          { label: batchLabel, url: `/companies/companyview?companyId=${companyId}&tab=batch&batchId=${batchId}` },
        ])
      );
      return;
    }

    if (!employeeId && !sessionView && !batchId && !coachId) {
      dispatch(
        setBreadcrumbs([
          { label: "Companies", url: "/companies", home: "/companies" },
          { label: companyLabel || 'View Company', url: `/companies/companyview?companyId=${companyId}&tab=${tabFromUrl}` },
        ])
      );
    }
  }, [
    dispatch, employeeId, sessionView, companyId, tabFromUrl, coachId, batchId,
    sessionTab, mangmentView, activeTab, sessionId, empId, companyDetail,
    storedCompanyName, storedManagementName, storedSessionName, sessionName,
  ]);

  // ✅ 3. Modal Handlers
  const openImagePreview = () => {
    // Only open if there is an actual logo URL (not initials)
    if (!companyData?.company_logo) return;
    
    setImageModal({ 
      isOpen: true, 
      url: companyData.company_logo, 
      alt: companyData.company_name || "Company Logo" 
    });
  };

  const closeImagePreview = () => {
    setImageModal({ isOpen: false, url: "", alt: "" });
  };

  const allTabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'employees', label: 'Employees' },
    { id: 'batch', label: 'Batch' },
    { id: 'sessions', label: 'Sessions' },
    { id: 'interviewCandidates', label: 'Interview Candidates' },
    { id: 'coaches', label: 'Coaches' },
    { id: 'management', label: 'Management' },
  ];

  const tabs = allTabs.filter(tab => {
    if (tab.id === 'interviewCandidates' || tab.id === 'coaches' || tab.id === 'management' || tab.id === 'batch') {
      return isAdmin;
    }
    return true;
  });

  return (
    <div>
      <div className="flex justify-between mb-5">
        <div className="w-full">

          {/* Header Section */}
          {(!employeeId && !batchId && !coachId && sessionTab !== "view" && !mangmentView && sessionView !== "view") && (
            <>
              <div className="flex items-center gap-4 mb-6">

                {/* ✅ 4. Wrap CompanyAvatar in a clickable div */}
                <div 
                  onClick={openImagePreview}
                  className={companyData?.company_logo ? "cursor-pointer hover:opacity-80 transition" : ""}
                  title={companyData?.company_logo ? "View Logo" : ""}
                >
                  <CompanyAvatar logo={companyData?.company_logo} name={companyData?.company_name} />
                </div>

                <div>
                  <div className="w-80 h-10 text-start">
                    <Heading>{companyData.company_name}</Heading>
                  </div>
                  <div className="flex items-center gap-3 mt-1">
                    <div className={`flex items-center gap-1 px-3 py-0.5 ${companyData.company_isActive ? " bg-[#ECFDF3]" : "bg-[#FEF3F2]"} rounded-[16px]`}>
                      {companyData.company_isActive ? <div className="w-2 h-2 bg-green-500 rounded-full"></div> : <div className="w-2 h-2 bg-red-500 rounded-full"></div>}
                      <span className={`font-lato font-medium text-[14px] ${companyData.company_isActive ? "text-[#027A48]" : "text-[#B42318]"} `}>
                        {companyData.company_isActive ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                    <span className="font-lato font-medium text-[14px] text-[#1D2939] flex items-center gap-2">

                      <span>{companyData.contact_email}</span>
                      {companyData.contact_phone && (
                        <>
                          {" • "}
                          <span>{companyData.contact_phone}</span>
                        </>
                      )}                    </span>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="flex gap-0 p-1 bg-[#FFF4E5] border border-[#FFF4E5] rounded-lg mb-6">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => handleTabChange(tab.id)}
                    className={`flex-1 text-sm font-normal transition-colors py-2 px-3 rounded-md ${activeTab === tab.id
                      ? 'text-gray-900 bg-white shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)]'
                      : 'text-gray-600 bg-[#FFF4E5]'
                      }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </>
          )}

          {/* Tab Content */}
          {activeTab === 'overview' && <CompanyInfoCard companyData={companyData} refresh={refresh} />}
          {activeTab === 'employees' && (
            employeeId
              ? <EmployeeView employeeId={employeeId} />
              : <EmployeesTab companydata={companyData} />
          )}

          {activeTab === 'batch' && isAdmin && (
            batchId ? <BatchView /> : <Batches companyId={companyId} isAdmin={isAdmin} />
          )}

          {sessionTab === 'view' ? (
            <SessionView companyData={companyData} />
          ) : activeTab === 'sessions' ? (
            <BatchesSessions companyData={companyData} />
          ) : null}

          {activeTab === 'interviewCandidates' && (
            <InterViewCandidate companyData={companyData} />
          )}

          {activeTab === 'coaches' && (
            <CompanyCoaches companyData={companyData} />
          )}

          {activeTab === 'management' ? (
            <ToolManagmentCard>
              <Management companyData={companyData} />
            </ToolManagmentCard>
          ) : (mangmentView || (activeTab === 'managementSessions' && sessionView === 'view')) ? (
            <ViewManagement managementId={managementId} />
          ) : null}

        </div>
      </div>

      {/* ✅ 5. Render the Modal */}
      <ImagePreviewModal
        isOpen={imageModal.isOpen}
        onClose={closeImagePreview}
        imageUrl={imageModal.url}
        altText={imageModal.alt}
      />
      
    </div>
  );
};

export default ViewCompany;